export default __webpack_public_path__ + "static/_MG_1247-54e05d2b2611fa056c6d56cb8e7d700d.jpg";